import {
  FixedGemsReward,
  Match2Reward,
} from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { TeamProfile } from '../team.schema';
import { TeamEventType, TeamMemberProfile } from '../team.ruleset';
import { TeamEventStatus } from '../team.getters';

export const MAX_TEAMS_PER_COMPETITION = 25;
export const MIN_MEMBERS_TO_JOIN_COMPETITION = 10;

export const TEAM_COMPETITION_REWARDS: FixedGemsReward[] = [
  { type: 'gems', amount: 25000 },
  { type: 'gems', amount: 20000 },
  { type: 'gems', amount: 15000 },
  { type: 'gems', amount: 10000 },
  { type: 'gems', amount: 5000 },
];

export type TeamCompetitor<
  T extends TeamProfile | TeamMemberProfile = TeamProfile | TeamMemberProfile,
> = {
  id: string;
  score: number;
  position: number;
  profile: T;
  current: boolean;
};

type CommonTeamCompetitionData = {
  id: string;
  sharedStateId: string;
  myTeam: TeamCompetitor<TeamMemberProfile>[];
  teams: TeamCompetitor<TeamProfile>[];
  rewards?: Match2Reward[];
  canJoin: boolean;
  joined: boolean;
  status: TeamEventStatus;
  score: number;
};

type TeamChestData = CommonTeamCompetitionData & {
  type: 'chest';
  targetScore: number;
};

type TeamCompetitionData = CommonTeamCompetitionData & {
  type: 'competition';
};

export type TeamEventData = TeamChestData | TeamCompetitionData;

export type UnlcaimedCompetitionData = TeamEventData & {
  previousScore: number;
  previousTeamScore: number;
  alreadyFinished: boolean;
  type: TeamEventType;
};
